<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Definizioni', route: '/backoffice/abbecedario/' }, { label: 'Aggiungi Definizione', route: '/backoffice/abbecedario/add' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">Aggiungi definizione</h1>
</section>

<section class="px-container pb-16">
    <form [formGroup]="formDefinizione" class="accrediti-form flex flex-col gap-6" (ngSubmit)="onSubmit()">
        <div class="ac-section-head">
            <h2>Dati definizione</h2>
            <span class="ac-meta">lettera, titolo e testo</span>
        </div>

        <div class="fld">
            <label>* Alfabeto</label>
            <p-dropdown [options]="alfabeto" optionLabel="lettera" placeholder="Seleziona una lettera dell'alfabeto" formControlName="alfabeto" styleClass="w-full"></p-dropdown>
            <small class="text-red-600 block mt-2 font-medium" *ngIf="formDefinizione.get('alfabeto')?.hasError('required') && (formDefinizione.get('alfabeto')?.dirty || formDefinizione.get('alfabeto')?.touched)">La lettera dell'alfabeto è obbligatoria.</small>
        </div>

        <div class="fld">
            <label>* Titolo</label>
            <input type="text" pInputText class="w-full" placeholder="Titolo" formControlName="titolo" name="titolo" id="titolo" required />
            <small class="text-red-600 block mt-2 font-medium" *ngIf="formDefinizione.get('titolo')?.hasError('required') && (formDefinizione.get('titolo')?.dirty || formDefinizione.get('titolo')?.touched)">Il titolo è obbligatorio.</small>
        </div>

        <div class="fld">
            <label>* Definizione</label>
            <p-editor [style]="{ height: '150px' }" formControlName="definizione" (ngModelChange)="onDefinizione($event)" />
            <small class="text-red-600 block mt-2 font-medium" *ngIf="formDefinizione.get('definizione')?.hasError('required') && (formDefinizione.get('definizione')?.dirty || formDefinizione.get('definizione')?.touched)">La descrizione è obbligatoria.</small>
        </div>

        <div class="acc-actions">
            <a class="acc-btn acc-btn-ghost" routerLink="/backoffice/abbecedario">Annulla</a>
            <button class="acc-btn acc-btn-primary" type="submit" [disabled]="!formDefinizione.valid">Aggiungi definizione</button>
        </div>
    </form>
</section>
